//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {useProductVariantContext} from '../../../context/productVariant';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';
import {useProductContext} from '../../../context';

const useStyles = makeStyles(theme => ({
  numberField: {
    width: '120px',
  },
}));

export default function VariantTaxedPriceCell() {
  const classes = useStyles();
  const [product] = useProductContext(product => {
    const taxes = product.taxes ?? [];
    const categoryTaxes = product.categoryTaxes ?? [];

    return {
      id: product.id,
      taxes: [...taxes, ...categoryTaxes]
        .map(parseFloat)
        .reduce((a, b) => a + b, 1),
    };
  });

  const variant = useProductVariantContext();

  const variantRequest = useProductVariantRequestContext();

  const defaultValue = (product.taxes * parseFloat(variant.price)).toFixed(5);

  const handleChange = price => {
    const withoutTaxPrice = price
      ? parseFloat(Number(price) / product.taxes).toFixed(5)
      : '';
    variantRequest.setTaxedPrice(variant.id, price);
    variantRequest.setPrice(variant.id, withoutTaxPrice);
  };

  if (!variant || !variantRequest) return null;

  return (
    <TableCell component="th" scope="row">
      <CustomTextField
        name="price"
        value={variant.taxedPrice}
        className={classes.numberField}
        type="number"
        defaultValue={defaultValue}
        inputProps={{
          step: '0.01',
        }}
        onChange={e => handleChange(e.target.value)}
      />
    </TableCell>
  );
}
